module.exports = __webpack_public_path__ + "static/img/35京兮.f43f34f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/35京兮.jpg
// module id = BsGn
// module chunks = 0